import NavbarEN from "../components/NavbarEN";
import FooterEN from "../components/FooterEN";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { FadeIn } from "../components/AnimationWrapper";
import { useRef } from "react";
import { Helmet } from "react-helmet-async";

export default function ContactEN() {
  const heroHeadingRef = useRef(null);

  return (
    <>
      <NavbarEN heroHeadingRef={heroHeadingRef} />
      <Helmet>
        <html lang="en" />
        <title>Contact – CV Box | Get in Touch</title>
        <meta name="description" content="Have questions about CV Box? Contact our support team for help with CV optimization, ATS checks, job tracking, or AI coaching." />
        <link rel="canonical" href="https://cv-box.com/en/contact" />
      </Helmet>

      <main>
        <section className="pt-32 lg:pt-44 pb-20 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] min-h-[40vh] flex items-center">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <FadeIn>
              <h1 ref={heroHeadingRef} className="text-4xl lg:text-5xl font-bold text-white mb-4">Get in Touch</h1>
              <p className="text-white/60 text-lg max-w-xl mx-auto">
                Have a question or need help? We're always happy to assist.
              </p>
            </FadeIn>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-2xl mx-auto px-6">
            <FadeIn>
              <div className="bg-white rounded-2xl p-8 shadow-feature-card">
                <h2 className="text-2xl font-medium text-gray-900 mb-6">Write to us</h2>
                <div className="space-y-6">
                  <div>
                    <p className="text-gray-700 text-lg mb-2">📧 Support email:</p>
                    <a href="mailto:support@cv-box.com" className="text-indigo-600 text-lg font-medium hover:text-indigo-700">support@cv-box.com</a>
                  </div>
                  <div>
                    <p className="text-gray-700 text-lg mb-2">⏱ Response time:</p>
                    <p className="text-gray-600">We typically respond within 24 hours on business days.</p>
                  </div>
                  <div>
                    <p className="text-gray-700 text-lg mb-2">💬 Topics we help with:</p>
                    <ul className="text-gray-600 space-y-2 list-disc list-inside">
                      <li>CV optimization and ATS checks</li>
                      <li>Credit purchases and payments</li>
                      <li>Technical issues with the platform</li>
                      <li>Feature suggestions</li>
                      <li>Partnership and business inquiries</li>
                    </ul>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>

      <ScrollToTopButton />
      <FooterEN />
    </>
  );
}
